import { z } from "zod";
import { addressSchema } from "./address.js";
import { offsetPaginatedResponseSchema } from "../pagination.js";
export const customFieldsSchema = z.record(z.unknown());
export const contactInputSchema = z.object({
    name: z.string().min(1).max(400),
    email: z.string().email().nullable().optional(),
    phone: z.string().nullable().optional(),
    address: addressSchema.optional(),
    notes: z.string().nullable().optional(),
    tags: z.array(z.string()).default([]),
    householdId: z.string().nullable().optional(),
    customFields: customFieldsSchema.default({}),
});
export const contactPatchSchema = contactInputSchema.partial();
/**
 * Body for POST /contacts/bulk. A discriminated union on `operation` so the
 * spec'd create/update operations can be added as further members later;
 * only `delete` is implemented today.
 */
export const contactBulkBodySchema = z.discriminatedUnion("operation", [
    z.object({
        operation: z.literal("delete"),
        ids: z.array(z.string()).min(1).max(1000),
    }),
]);
/** Result of a bulk operation; `deletedCount` is the rows actually removed. */
export const contactBulkResultSchema = z.object({
    deletedCount: z.number().int().nonnegative(),
});
export const contactSchema = contactInputSchema.extend({
    id: z.string(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
/**
 * Response shape for GET /contacts/:id and POST /contacts.
 * Tightens `tags` to a required array (the input schema defaults it for
 * convenience on writes) and includes a `household` summary when assigned.
 */
export const contactHouseholdSummarySchema = z.object({
    id: z.string(),
    displayName: z.string().nullable(),
});
export const contactResponseSchema = contactSchema.extend({
    tags: z.array(z.string()),
    household: contactHouseholdSummarySchema.nullable(),
});
/** Minimal row shape returned by GET /contacts list. */
export const contactListItemSchema = z.object({
    id: z.string(),
    name: z.string().nullable(),
    email: z.string().nullable(),
    phone: z.string().nullable(),
    // First line of the canonical mailing address: household.line1 when the
    // contact belongs to a household (households own the canonical address
    // per schema.md), otherwise the contact's own line1. Null when neither.
    addressLine: z.string().nullable(),
    tags: z.array(z.string()),
    household: contactHouseholdSummarySchema.nullable(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
export const contactListResponseSchema = offsetPaginatedResponseSchema(contactListItemSchema);
//# sourceMappingURL=contact.js.map